<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="商品名称" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsName" placeholder="请输入商品名称"></el-input>
					</el-form-item>
					<el-form-item label="商品编号" class='tiny' cleartable>
						<el-input style="width: 200px;" v-model="searchInfo.goodsCode" placeholder="请输入商品编号"></el-input>
					</el-form-item>
					<el-form-item label="商品状态" class='tiny' cleartable>
						<el-select v-model="searchInfo.status" placeholder="请选择">
							<el-option key="0" label="下架" :value="0">下架</el-option>
							<el-option key="1" label="上架" :value="1">上架</el-option>
						</el-select>
					</el-form-item>
				<!-- 	<el-form-item label="是否兑换" class='tiny' cleartable>
						<el-select v-model="searchInfo.isDh" placeholder="请选择">
							<el-option key="true" label="是" :value="true">是</el-option>
							<el-option key="false" label="否" :value="false">否</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否爆品" class='tiny' cleartable>
						<el-select v-model="searchInfo.isCrontab" placeholder="请选择">
							<el-option key="0" label="是" :value="true"></el-option>
							<el-option key="1" label="否" :value="false"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- 	<el-form-item label="是否超值精选" class='tiny' cleartable>
						<el-select v-model="searchInfo.isDiscounts" placeholder="请选择">
							<el-option key="0" label="是" :value="true"></el-option>
							<el-option key="1" label="否" :value="false"></el-option>
						</el-select>
					</el-form-item> -->
<!-- 
					<el-form-item label="是否体验区" class='tiny' cleartable>
						<el-select v-model="searchInfo.isChoiceness" placeholder="请选择">
							<el-option key="0" label="是" :value="true"></el-option>
							<el-option key="1" label="否" :value="false"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="排序方式" class='tiny' cleartable>
						<el-select v-model="searchInfo.orderType" placeholder="默认修改时间降序">
							<el-option key="0" label="修改时间升序" :value="0"></el-option>
							<el-option key="3" label="创建时间降序" :value="3"></el-option>
							<el-option key="4" label="创建时间升序" :value="4"></el-option>
							<el-option key="1" label="排序等级降序" :value="1"></el-option>
							<el-option key="2" label="排序等级升序" :value="2"></el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="dialogVisibleFun()">新增商品
							</el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="goodsList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand">
						<el-form-item label="供应商名称">
							<span v-if="props.row.storeId!=0">{{ props.row.storeName }}</span>
							<span v-else>自营</span>
						</el-form-item>
						<el-form-item label="商品ID">
							<span>{{ props.row.id }}</span>
						</el-form-item>
						<el-form-item label="商品名称">
							<span>{{ props.row.goodsName }}</span>
						</el-form-item>
						<el-form-item label="商品分类">
							<span>{{ props.row.className }}</span>
						</el-form-item>
						<el-form-item label="商品编号">
							<span>{{ props.row.goodsCode?props.row.goodsCode:'无' }}</span>
						</el-form-item>
						<el-form-item label="市场价">
							<span>￥{{ props.row.marketPrice }}</span>
						</el-form-item>
						<el-form-item label="零售价">
							<span>￥{{ props.row.price }}</span>
						</el-form-item>
						<el-form-item label="供应价">
							<span>￥{{ props.row.costPrice }}</span>
						</el-form-item>
					<!-- 	<el-form-item label="是否兑换">
							<span v-if="props.row.isDh">是</span>
							<span v-else>否</span>
						</el-form-item>
						<el-form-item label="是否爆品">
							<span v-if="props.row.isCrontab">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<!-- <el-form-item label="是否超值精选">
							<span v-if="props.row.isDiscounts">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<!-- <el-form-item label="是否体验区">
							<span v-if="props.row.isChoiceness">是</span>
							<span v-else>否</span>
						</el-form-item> -->
						<el-form-item label="排序级别">
							<span>{{ props.row.orderIndex }}</span>
						</el-form-item>
						<el-form-item label="商品简单描述">
							<span>{{ props.row.remark?props.row.remark:'无' }}</span>
						</el-form-item>
						<el-form-item label="商品详细描述">
							<el-button size="small" type="text" @click="findDetail(props.row.detail,1)">点击查看</el-button>
						</el-form-item>
						<el-form-item label="商品图片">
							<el-button size="small" type="text" @click="findDetail(props.row.images,2)">点击查看</el-button>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="商品ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="goodsName" label="商品名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="status" label="商品状态" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.status==0">下架</p>
					<p v-if="scope.row.status==1">上架</p>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="status" label="是否兑换" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<p v-if="scope.row.isDh==true">是</p>
					<p v-if="scope.row.isDh==false">否</p>
				</template>
			</el-table-column> -->
			<el-table-column prop="stock" label="库存" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="price" label="价格/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="marketPrice" label="市场价/元" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="createTime" label="创建时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="updateTime" label="更新时间" sortable align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<!-- <el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">编辑</el-button>　　 -->
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==0 && scope.row.authStatus==1">上架</el-dropdown-item>
							<el-dropdown-item @click.native="storeGoodsHitTheShelfOrSoldOut(scope.row.id)"
								v-if="scope.row.status==1 && scope.row.authStatus==1">下架</el-dropdown-item>
							<!-- <el-dropdown-item @click.native="toDelete(scope.row)">删除</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>　　
				</template>　
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px;" background :current-page="goodsList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="goodsList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 详情查看 -->
		<el-dialog style="float:rigin" title="详情查看" :closeOnClickModal="false" :visible.sync="dialogVisibleDetails"
			width="50%">
			<div class="detailImg" v-if="detailType == 1" v-html="detail"></div>
			<div v-if="detailType == 2"
				style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap;">
				<img style="width:40%;margin: 20px;" :src="image" v-for="(image,index) in  images" :key="index" />
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleDetails = false">关 闭</el-button>
			</div>
		</el-dialog>
		<!-- 编辑商家 -->
		<el-dialog style="float:rigin" :title="dialogVisibleFunName" :closeOnClickModal="false"
			:visible.sync="dialogVisible" width="80%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="border: 1px solid lightgrey;padding: 10px;margin-bottom: 20px;">
						<div style="text-align: left;">
							请选择供应商：
						</div>
						<div style="display: flex;align-items: center;justify-content: space-between;">
							<el-form-item label="用户名">
								<el-input type="text" clearable v-model="storeGoodsInfo.username"
									placeholder="请输入用户名(搜索条件)" />
							</el-form-item>
							<el-form-item label="供应商名称">
								<el-input type="text" clearable v-model="storeGoodsInfo.storeName"
									placeholder="请输入供应商名称(搜索条件)" />
							</el-form-item>
							<el-form-item label="搜索按钮">
								<el-button type="primary" @click="searchStore">搜 索</el-button>
							</el-form-item>
						</div>

						<div style="display: flex;align-items: center;justify-content: space-between;">

							<el-form-item label="选择供应商">
								<el-select v-model="storeGoodsInfo.storeId" class="big" placeholder="请选择"
									@change="getStoreAndUser">
									<el-option v-for="item in accountList" :key="item.id" :value="item.id"
										:label="item.storeName+'('+item.username+')'">
									</el-option>
								</el-select>
							</el-form-item>
						</div>
					</div>

					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品名称" style="width: 50%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsName" placeholder="请输入商品名称" />
						</el-form-item>
						<el-form-item label="商品编号" style="width: 40%;">
							<el-input type="text" clearable v-model="storeGoodsInfo.goodsCode" placeholder="请输入商品编号" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品分类">
							<el-col :span="13.5">
								<el-select clearable v-model="classGoods1Id" placeholder="请选择一级分类"
									style="width:30%;margin-right:10px;" @change="classGoods1">
									<el-option clearable v-for="item in classGoods1List" :key="item.id"
										:label="item.className" :value="item.id"></el-option>
								</el-select>
								<el-select clearable v-model="classGoods2Id" placeholder="请选择二级分类"
									style="width:30%;margin:  0px 10px;" @change="classGoods2">
									<el-option v-for="item in classGoods2List" :key="item.id" :label="item.className"
										:value="item.id">
									</el-option>
								</el-select>
								<el-select clearable v-model="classGoods3Id" placeholder="请选择三级分类"
									style="width:30%;margin:  0px 10px;" @change="classGoods3">
									<el-option v-for="item in classGoods3List" :key="item.id" :label="item.className"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="市场价(￥)" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.marketPrice" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item label="零售价格(￥)" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.price" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item label="供应价" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9.]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.costPrice" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="排序级别" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.orderIndex" placeholder="请输入数字(降序)" />
						</el-form-item>
						<el-form-item label="销量" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.salesSum" placeholder="请输入数字" />
						</el-form-item>
						<el-form-item label="库存" class="redItem">
							<el-input type="text" oninput="value=value.replace(/[^0-9]/g,'')" size="small" width="50"
								v-model="storeGoodsInfo.stock" placeholder="请输入数字" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;flex-direction: row;">
						<el-form-item label="是否兑换" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isDh" :active-value="true" :inactive-value="false"
								@change="handleIsDh">
							</el-switch>
						</el-form-item>
						<el-form-item label="是否上架" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;">
						<el-form-item label="是否爆品" class="redItem" style="flex: 25%;">
							<el-switch v-model="storeGoodsInfo.isCrontab" :active-value="true" :inactive-value="false"
								@change="selectisCrontab">
							</el-switch>
						</el-form-item>
						<!-- <el-form-item label="是否超值精选" class="redItem" style="flex: 25%;" >
							<el-switch v-model="storeGoodsInfo.isDiscounts" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item> -->
						<el-form-item label="是否体验区" class="redItem" style="flex: 25%;"
							v-if="storeGoodsInfo.isCrontab==true">
							<el-switch v-model="storeGoodsInfo.isChoiceness" :active-value="true"
								:inactive-value="false" @change="selectisChoiceness">
							</el-switch>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="商品图片(1:1)" style="width: 100%;display: flex;align-items: initial;">
							<br />
							<el-upload :action="httpUrl" list-type="picture-card" :on-preview="handlePictureCardPreview"
								:on-remove="handleRemove" :file-list="fileList" :show-file-list="true"
								:on-success="onSuccess">
								<i class="el-icon-plus"></i>
							</el-upload>
						</el-form-item>
					</div>
					<div>
						<div style="text-align: start;margin: 10px;">商品详情</div>
						<el-form-item>
							<div id="lpc-quill" class="quill">
								<el-upload class="upload-demo" v-show="false" ref="upload" :action="httpUrl"
									:before-upload="beforeAvatarUpload" :on-success="upScuccess"
									:on-error="uploadError" />
								<quill-editor v-model="storeGoodsInfo.detail" ref="myQuillEditor" class="editer"
									:options="editorOption" @ready="onEditorReady($event)">
								</quill-editor>
							</div>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div style="text-align: center;">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button v-if="dialogVisibleFunName == '新增商品'" type="primary" @click="add">添 加</el-button>
				<el-button v-if="dialogVisibleFunName == '编辑商品'" type="primary" @click="sure">编 辑</el-button>
			</div>
		</el-dialog>
		<el-dialog :visible.sync="dialogVisibleImg" :closeOnClickModal="false">
			<div style="text-align: center;">
				<img width="100%" class="el-upload-list__item-thumbnail" :src="dialogImageUrl" alt="">
			</div>
			<div style="text-align: center;">
				<el-button type="primary" @click="dialogVisibleImg = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('offline');

	import {
		quillEditor
	} from "vue-quill-editor"; //调用编辑器
	import "quill/dist/quill.core.css";
	import "quill/dist/quill.snow.css";
	import "quill/dist/quill.bubble.css";

	Array.prototype.remove = function(val) {
		var index = this.indexOf(val);
		if (index > -1) {
			this.splice(index, 1);
		}
	};

	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				buy: {
					goodId: null,
					goodsName: null,
					price: null,
					num: null,
					storeId: null,
					status: null,
					goodsImages: ""
				},
				setUpBuyVisible: false,
				goodsImages: [],
				fileList: [],
				dialogVisibleImg: false,
				dialogImageUrl: '',
				httpUrl: urls,
				loading: false,
				goodsList: [{}], //列表
				dialogVisible: false,
				editDialogVisible: false,
				dialogVisibleFunName: '',
				accountList: [],
				dialogVisibleDetails: false,
				detail: '',
				images: [],
				detailType: 0,
				classGoods1List: [],
				classGoods2List: [],
				classGoods3List: [],
				classGoods1Id: "",
				classGoods2Id: "",
				classGoods3Id: "",
				storeGoodsInfo: {
					classId: "",
					isDh: false,
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				storeGoodsId: '', //授权用户id
				form: {
					refuseReason: ""
				},
				mainFormRules: {
					refuseReason: {
						required: true,
						message: "请输入驳回原因",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				editorOption: {
					// 富文本编辑器配置
					placeholder: "请输入内容",
					modules: {
						toolbar: {
							container: [
								["bold", "italic", "underline", "strike"], // 加粗，斜体，下划线，删除线
								[{
										header: 1,
									},
									{
										header: 2,
									},
								], // 标题，键值对的形式；1、2表示字体大小
								[{
										list: "ordered",
									},
									{
										list: "bullet",
									},
								], // 列表
								[{
										script: "sub",
									},
									{
										script: "super",
									},
								], // 上下标
								[{
										indent: "-1",
									},
									{
										indent: "+1",
									},
								], // 缩进
								[{
									direction: "rtl",
								}, ], // 文本方向
								[{
									size: ["small", false, "large", "huge"],
								}, ], // 字体大小
								[{
										color: [],
									},
									{
										background: [],
									},
								], // 字体颜色，字体背景颜色
								[{
									align: [],
								}, ], // 对齐方式
								["clean"], // 清除字体样式
								["image"], // 上传图片、上传视频
							],
							handlers: {
								image: function(value) {
									console.log(value)
									if (value) {
										document
											.querySelector("#lpc-quill .upload-demo input")
											.click();
									} else {
										this.quill.format("image", false);
									}
								},
							},

						},
					},
					theme: "snow",
				}

			};
		},

		methods: {
			selectisCrontab(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isCrontab = false

				} else {
					this.storeGoodsInfo.isCrontab = e

				}
				this.$forceUpdate()
			},
			selectisChoiceness(e) {
				if (this.storeGoodsInfo.isDh == true) {
					e = false
					this.storeGoodsInfo.isChoiceness = false

				} else {
					this.storeGoodsInfo.isChoiceness = e

				}
				this.$forceUpdate()
			},
			handleIsDh(e) {
				if (e == true) {
					this.storeGoodsInfo.isCrontab = false
					this.storeGoodsInfo.isChoiceness = false
				}
			},
			onSuccess(response, file, fileList) {
				// console.log(res)
				this.goodsImages.push(response.data);
				// console.log("asda",response,this.goodsImages)
			},
			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				this.goodsImages.remove(file.url);
			},
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			searchStore() {
				let data = {
					username: this.storeGoodsInfo.username,
					storeName: this.storeGoodsInfo.storeName
				}
				this.$api.getStoreList(this.$encrypt(data)).then((res) => {
					res.data=JSON.parse(this.$decrypt(res.data)).data
					if (res.state == 'success') {
						this.storeGoodsInfo.storeId = res.data.list[0].id
						this.accountList = res.data.list;
					} else {
						this.$message.error(res.message);
					}
				})
			},
			findDetail(string, type) {
				this.dialogVisibleDetails = true;
				this.detailType = type;
				if (type == 1) {
					this.detail = string;

				}
				if (type == 2) {
					this.images = string.split(",");
				}
			},
			storeGoodsHitTheShelfOrSoldOut(id) {
				this.$api.storeGoodsHitTheShelfOrSoldOut(id).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getStoreGoodsList()
			},
			//店铺审核
			editStoreInfoCheck(id, authStatus) {
				if (authStatus == 2) {
					//通过驳回
					var data = {
						id: this.storeGoodsId,
						authStatus: authStatus,
						rejected: this.form.refuseReason
					}
				} else {
					//通过审核
					var data = {
						id: id,
						authStatus: authStatus
					}
				}
				this.$api.storeGoodsReview(this.$encrypt(data)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.editDialogVisible = false
						this.getStoreGoodsList()
					} else {
						this.$message.error(res.message);
					}
				})

			},

			//审核驳回弹窗关闭
			cannelPass() {
				this.editDialogVisible = false
			},
			//审核驳回弹窗打开
			editialogVisible(id) {
				this.form.refuseReason = ""
				this.storeGoodsId = id
				this.editDialogVisible = true;
			},
			// 店铺编辑弹窗
			dialogVisibleFun(id) {
				this.storeInfo = {}
				this.dialogVisibleFunName = "新增商品"
				this.dialogVisible = true;
				this.storeGoodsInfo = {
					// isDh:false,

				};
				this.classGoods2List = [];
				this.classGoods3List = [];
				this.classGoods1Id = "";
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.goodsImages = [];
				this.fileList = [];
				this.searchStore();
				if (id) {
					this.dialogVisibleFunName = "编辑商品"
					this.storeGoodsId = id
					this.$api.storeGoodsFindById(this.storeGoodsId).then((res) => {
						res=JSON.parse(this.$decrypt(res.data))
						if (res.state == 'success') {
							this.storeGoodsInfo = res.data
							if (res.data.classId) {
								this.$api.findByGoodsClassId(res.data.classId).then((res) => {
									if (res.state == 'success') {
										if (res.data.level == 1) {
											this.classGoods1Id = res.data.id;
											let obj = {};
											obj = this.classGoods1List.find((
												item) => { //这里的userList就是上面遍历的数据源
												return item.id === this.classGoods1Id; //筛选出匹配数据
											});
											this.storeGoodsInfo.className = obj.className;

										} else if (res.data.level == 2) {
											this.classGoods2Id = res.data.id;
											this.$api.findByGoodsClassId(res.data.pid).then((res) => {
												if (res.state == 'success') {
													this.$api.goodsClassfindByPid(res.data.id)
														.then((res) => { //商品二级分类
															if (res.state == 'success') {
																this.classGoods2List = res
																	.data;

																let obj = {};
																obj = this.classGoods2List
																	.find((item) => { //这里的userList就是上面遍历的数据源
																		return item.id ===
																			this
																			.classGoods2Id; //筛选出匹配数据
																	});
																this.storeGoodsInfo.className =
																	obj.className;
															}
														})
													this.classGoods1Id = res.data.id;
												} else {
													this.$message.error(res.message);
												}
											})

										} else if (res.data.level == 3) {
											this.classGoods3Id = res.data.id;
											this.$api.findByGoodsClassId(res.data.pid).then((res) => {
												if (res.state == 'success') {
													this.classGoods2Id = res.data.id;
													this.$api.goodsClassfindByPid(res.data.id)
														.then((res) => { //商品三级分类
															if (res.state == 'success') {
																this.classGoods3List = res
																	.data;

																let obj = {};
																obj = this.classGoods3List
																	.find((item) => { //这里的userList就是上面遍历的数据源
																		return item.id ===
																			this
																			.classGoods3Id; //筛选出匹配数据
																	});
																this.storeGoodsInfo.className =
																	obj.className;
															}
														})
													this.$api.findByGoodsClassId(res.data.pid)
														.then((res) => {
															if (res.state == 'success') {
																this.classGoods1Id = res.data
																	.id;
																this.$api.goodsClassfindByPid(
																	res.data.id).then((
																	res) => { //商品二级分类
																	if (res.state ==
																		'success') {
																		this.classGoods2List =
																			res.data;
																	}
																})
															} else {
																this.$message.error(res
																	.message);
															}
														})
												} else {
													this.$message.error(res.message);
												}
											})
										}
									} else {
										this.$message.error(res.message);
									}
								})
							}
							let imagesArray = res.data.images.split(",");
							this.goodsImages = imagesArray;
							for (let i = 0; i < imagesArray.length; i++) {
								this.fileList.push({
									name: imagesArray[i],
									url: imagesArray[i]
								})
							}

						}
					})
				}
			},
			//添加商品
			add() {
				this.storeGoodsInfo.images = this.goodsImages.toString();
				// console.log(this.goodsImages.toString(),this.goodsImages)
				// this.storeGoodsInfo.storeId = 1
				// console.log(this.storeGoodsInfo)
				
				this.storeGoodsInfo.isDh==true?this.storeGoodsInfo.isDh:false
				this.storeGoodsInfo.isCrontab==true?this.storeGoodsInfo.isCrontab:false
				this.storeGoodsInfo.isChoiceness==true?this.storeGoodsInfo.isChoiceness:false
				// if(this.storeGoodsInfo.isDh===true){
				// 	delete this.storeGoodsInfo.isCrontab
				// 	delete this.storeGoodsInfo.isDiscounts
				// 	delete this.storeGoodsInfo.isChoiceness
				// }
				this.$api.addStoreGoods(this.$encrypt(this.storeGoodsInfo)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			//编辑商品
			sure() {
				this.storeGoodsInfo.images = this.goodsImages.toString();
				// if(this.storeGoodsInfo.isDh===true){
				// 	delete this.storeGoodsInfo.isCrontab
				// 	delete this.storeGoodsInfo.isDiscounts
				// 	delete this.storeGoodsInfo.isChoiceness
				// }
				this.$api.editStoreGoods(this.$encrypt(this.storeGoodsInfo)).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisible = false;
						this.getStoreGoodsList();
					} else {
						this.$message.error(res.message);
					}
				})

			},
			//删除
			toDelete(row) {
				/* if (row.status == 0) {
					var str = "此操作将启用该店铺账号, 是否继续?"
				} else {
					var str = "此操作将禁用该店铺账号, 是否继续?"
				} */
				var str = "此操作将删除该商品, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delStoreGoods(row.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getStoreGoodsList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			pageChange(data) {
				this.page.pageNum = data
				this.getStoreGoodsList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getStoreGoodsList()
			},
			getStoreGoodsList() {
				this.loading = true
				this.searchInfo.pageNum = this.page.pageNum;
				this.searchInfo.pageSize = this.page.pageSize;
				this.$api.getStoreGoodsListOffline(this.searchInfo).then((res) => { //商品列表
					if (res.state == 'success') {
						this.goodsList = res.data
						this.loading = false
					}
				})
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			getStoreAndUser(e) {
				// console.log(e);
				let obj = {};
				obj = this.accountList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.username = obj.username;
				this.storeGoodsInfo.storeName = obj.storeName;
				this.storeGoodsInfo.userId = obj.userId;
				this.$forceUpdate()
				// console.log(this.storeGoodsInfo.username,this.storeGoodsInfo.storeName,this.storeGoodsInfo.userId)
			},
			//选中一级分类
			classGoods1(e) {
				console.log(1)
				this.classGoods2Id = "";
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					console.log(e)
					this.$api.goodsClassfindByPid(e).then((res) => { //商品二级分类
						if (res.state == 'success') {
							this.classGoods2List = res.data;
						}
					})
				}
			},
			//选中二级分类
			classGoods2(e) {
				console.log(e)
				this.classGoods3Id = "";
				this.classGoods3List = {};
				if (e) {
					this.$api.goodsClassfindByPid(e).then((res) => { //商品三级分类
						if (res.state == 'success') {
							this.classGoods3List = res.data;
						}
					})
				}
			},
			//选中三级分类
			classGoods3(e) {
				console.log(e)
				let obj = {};
				obj = this.classGoods3List.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});
				this.storeGoodsInfo.className = obj.className;
				this.storeGoodsInfo.classId = obj.id;
			},
			//上传店铺logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.storeLogo = res.message
				})
			},
			// 上传身份证正面图片
			upLoadLegalIdFace(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.legalIdFace = res.message
				})
			},
			// 上传身份证反面图片
			upLoadLegalIdBack(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					console.log('列表:', res);
					this.storeInfo.legalIdBack = res.message
				})
			},

			// 点击文件触发
			handlePreview(file) {
				// console.log(file)
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				// console.log(file)1048576
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				}
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				}
				return isLt2M, imgStr;
			},
			upScuccess(res, file) {
				const quill = this.$refs.myQuillEditor.quill;
				if (res.state == "success" && res.data !== null) {
					const length = quill.getSelection().index; // 获取光标所在位置
					quill.insertEmbed(length, "image", res.data); // 插入图片
					quill.setSelection(length + 1); // 调整光标位置到最后
				} else {
					this.$message.error("图片上传失败");
				}
			},
			uploadError() {
				this.$message.error("图片上传失败");
			},
			onEditorReady(editor) {
				// 准备编辑器
				// console.log(editor);
			}
		},
		created() {
			this.getStoreGoodsList();
			// this.$api.goodsClassfindByPid(0).then((res) => { //商品一级分类
			// 	if (res.state == 'success') {
			// 		this.classGoods1List = res.data;
			// 	}
			// })
		}

	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		width: 100px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}


	.avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		width: 200px;
		height: 100px;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.detailImg img {
		width: 100%;
	}

	.redItem {
		display: flex;
		flex-direction: row;
		align-items: center;
	}
</style>
